import angular from 'angular';
import DateGroupComponent from './date-group.component';

const dateGroup = angular
	.module('dateGroup', [])
	.component('dateGroup', DateGroupComponent)
	.name;

export default dateGroup;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/date-group/date-group.module.js